<template>
    <div class="administration">
        <div v-if="currentlyLoggedUser" class="administration-panel">
          <div class="administration-header">
            <div class="administration-header-inner">
              <div class="administration-logo-and-tabs">
                <img class="administration-logo" src="/static/img/admin/logo_white.png" alt="Alcomet administration">
                <div class="administration-tabs">
                  <span class="administration-tab" :class="{ 'administration-tab-active' : selectedTab === 1 }" @click="selectedTab = 1">Новини</span>
                  <span class="administration-tab" :class="{ 'administration-tab-active' : selectedTab === 2 }" @click="selectedTab = 2">Медиите за нас</span>
                  <span class="administration-tab" :class="{ 'administration-tab-active' : selectedTab === 3 }" @click="selectedTab = 3">Кариери</span>
                </div>
              </div>
              <div>
                <a class="administration-create" v-if="selectedTab === 3" @click="openCareerModal = true">Нова публикация</a>
                <a class="administration-create" v-else @click="openNewsModal = true">Нова публикация</a>
                <a class="administration-logout" @click="logout()">Изход</a>
              </div>
            </div>
          </div>
          <transition name="fade" mode="out-in">
            <div v-if="selectedTab === 1" class="administration-content" key="content1">
              <!-- ALL NEWS -->
              <ul v-if="news && news.length > 0" class="administrations-item-ul">
                <li class="administrations-item-li" v-for="(newsItem, index) in news" :key="'news-' + index" v-if="!newsItem.isMediaNews" @click="editNews(newsItem.url)">
                  <span>
                    <span class="administrations-item-date">{{newsItem.date | formatDate}}</span>
                    <span v-if="newsItem.content.bg.title">{{newsItem.content.bg.title}}</span>
                    <span v-else-if="newsItem.content.en.title">{{newsItem.content.en.title}}</span>
                    <span v-else-if="newsItem.content.de.title">{{newsItem.content.de.title}}</span>
                    <span v-else-if="newsItem.content.it.title">{{newsItem.content.it.title}}</span>
                  </span>
                  <span>
                    <span class="delete" @click.stop="deleteNews(newsItem._id)">
                        <svg aria-hidden="true" data-prefix="fas" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14 trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"></path></svg>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
            <div v-else-if="selectedTab === 2" class="administration-content" key="content2">
              <!-- ALL NEWS -->
              <ul v-if="news && news.length > 0" class="administrations-item-ul">
                <li class="administrations-item-li" v-for="(newsItem, index) in news" :key="'news-' + index" v-if="newsItem.isMediaNews" @click="editNews(newsItem.url)">
                  <span>
                    <span class="administrations-item-date">{{newsItem.date | formatDate}}</span>
                    <span v-if="newsItem.content.bg.title">{{newsItem.content.bg.title}}</span>
                    <span v-else-if="newsItem.content.en.title">{{newsItem.content.en.title}}</span>
                    <span v-else-if="newsItem.content.de.title">{{newsItem.content.de.title}}</span>
                    <span v-else-if="newsItem.content.it.title">{{newsItem.content.it.title}}</span>
                  </span>
                  <span>
                    <span class="delete" @click.stop="deleteNews(newsItem._id)">
                        <svg aria-hidden="true" data-prefix="fas" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14 trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"></path></svg>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
            <div v-else class="administration-content" key="content3">
              <ul v-if="careers && careers.length > 0" class="administrations-item-ul">
                <li class="administrations-item-li" v-for="(careerItem, index) in careers" :key="'news-' + index"  @click="editCareer(careerItem._id)">
                  <span>
                    <span class="administrations-item-date">{{careerItem.startDate | formatDate}} / {{careerItem.endDate | formatDate}}</span>
                    <span v-if="careerItem.title">{{careerItem.title}}</span>
                  </span>
                  <span class="item-icons">
                    <span class="visible" v-if="isCareerVisible(careerItem)">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.94 99.76"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M178.25,45.31a159.2,159.2,0,0,0-25.53-22.56C131.87,7.87,110.17,0,90,0S48.07,7.87,27.22,22.75A159.15,159.15,0,0,0,1.69,45.31a7,7,0,0,0,0,9.14A158.17,158.17,0,0,0,27.22,77C48.06,91.89,69.76,99.76,90,99.76s41.9-7.87,62.75-22.75a159.69,159.69,0,0,0,25.53-22.56A7,7,0,0,0,178.25,45.31ZM90,85.81c-21.75,0-41.61-10.88-54.45-20A157,157,0,0,1,16.61,49.88,156.21,156.21,0,0,1,35.52,34C48.35,24.84,68.22,14,90,14s41.61,10.89,54.44,20a155.68,155.68,0,0,1,18.92,15.91,156.34,156.34,0,0,1-18.92,15.91C131.58,74.93,111.72,85.81,90,85.81Z"/><path class="cls-1" d="M115.84,42.91a7,7,0,0,0-7,7,18.92,18.92,0,1,1-6.46-14.22,7,7,0,0,0,9.85-.65,7,7,0,0,0-.65-9.84,32.82,32.82,0,1,0,11.21,24.71A7,7,0,0,0,115.84,42.91Z"/><path class="cls-1" d="M78,49.88a12,12,0,1,0,12-12A12,12,0,0,0,78,49.88Z"/></g></g></svg>
                    </span>
                    <span class="delete" @click.stop="deleteCareer(careerItem._id)">
                        <svg aria-hidden="true" data-prefix="fas" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14 trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"></path></svg>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </transition>
          <transition name="modal">
            <app-news-modal v-if="openNewsModal" :isMedia="selectedTab === 2 ? true : false" :isEditing="isEditingNews" :url="editingNewsUrl"></app-news-modal>
          </transition>
          <transition name="modal">
            <app-career-modal v-if="openCareerModal" :isEditing="isEditingCareer" :id="editingCareerId"></app-career-modal>
          </transition>
        </div>
    </div>
</template>

<script>
import NewsModal from "./NewsModal";
import CareerModal from "./CareerModal";
export default {
  components: {
    appNewsModal: NewsModal,
    appCareerModal: CareerModal
  },
  data() {
    return {
      currentlyLoggedUser: undefined,
      openNewsModal: false,
      isEditingNews: false,
      editingNewsUrl: "",
      openCareerModal: false,
      isEditingCareer: false,
      editingCareerId: "",
      selectedTab: 1,
      news: [],
      careers: []
    };
  },
  methods: {
    getNews() {
      this.news = [];
      this.$http
        .get(`${process.env.ROOT_API}/news`)
        .then(response => {
          response.data.news.forEach(item => {
            this.news.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    editNews(url) {
      this.openNewsModal = true;
      this.editingNewsUrl = url;
      this.isEditingNews = true;
    },
    deleteNews(id) {
      if (confirm("Сигурни ли сте, че искате да изтриете новината?")) {
        this.$http
          .delete(`${process.env.ROOT_API}/news/${id}`)
          .then(response => {
            this.getNews();
          })
          .catch(error => {
            // handle error
            console.log(error);
          })
          .then(() => {
            // always executed
          });
      }
    },
    getCareers() {
      this.careers = [];
      this.$http
        .get(`${process.env.ROOT_API}/careers`)
        .then(response => {
          response.data.careers.forEach(item => {
            this.careers.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    editCareer(id) {
      this.openCareerModal = true;
      this.editingCareerId = id;
      this.isEditingCareer = true;
    },
    deleteCareer(id) {
      if (confirm("Сигурни ли сте, че искате да изтриете позицията?")) {
        this.$http
          .delete(`${process.env.ROOT_API}/careers/${id}`)
          .then(response => {
            this.getCareers();
          })
          .catch(error => {
            // handle error
            console.log(error);
          })
          .then(() => {
            // always executed
          });
      }
    },
    isCareerVisible(career) {
      const start = new Date(career.startDate).getTime();
      const end = new Date(career.endDate).getTime();
      let now = new Date();
      now.setHours(0, 0, 0, 0);
      now = now.getTime();
      if (start < now && now <= end) {
        return true;
      }
      return false;
    },
    isLoggedIn() {
      const token = localStorage.getItem("token");
      this.$http({
        url: `${process.env.ROOT_API}/admin/validate`,
        data: { token: token },
        method: "POST"
      })
        .then(res => {
          if (res.data.user) {
            this.currentlyLoggedUser = res.data.user;
          } else {
            this.currentlyLoggedUser = undefined;
            this.$router.push("/admin/login");
          }
        })
        .catch(err => {
          this.$router.push("/admin/login");
        });
    },
    logout() {
      localStorage.removeItem("token");
      this.currentlyLoggedUser = undefined;
      this.$router.push("/admin/login");
    }
  },
  mounted() {
    this.isLoggedIn();
    this.getNews();
    this.getCareers();

    this.$eventHub.$on("close-create-news", () => {
      this.openNewsModal = false;
      this.isEditingNews = false;
      this.editingNewsUrl = "";
      this.getNews();
    });

    this.$eventHub.$on("close-create-career", () => {
      this.openCareerModal = false;
      this.isEditingCareer = false;
      this.editingCareerId = "";
      this.getCareers();
    });
  },
  destroyed() {
    this.$eventHub.$off("close-create-news");
    this.$eventHub.$off("close-create-career");
  }
};
</script>

<style scoped>
.administration {
  align-items: center;
  background-color: #eff3f6;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  min-width: 1280px;
}
.administration-panel {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  width: 100%;
}
.administration-header {
  background-color: #2b579a;
  height: 60px;
  width: 100%;
}
.administration-header-inner {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  margin: 0 auto;
  width: 1200px;
}
.administration-logo-and-tabs {
  align-items: center;
  display: flex;
}
.administration-logo {
  height: auto;
  margin: 10px 20px 10px 0;
  width: 160px;
}
.administration-tabs {
  align-items: flex-end;
  height: 60px;
  display: flex;
}
.administration-tab {
  align-items: center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: flex;
  height: 47px;
  margin: 0 1px;
  padding: 0 35px;
}
.administration-tab:hover {
  background-color: #4770af;
  color: #fff;
}
.administration-tab-active,
.administration-tab-active:hover {
  background-color: #eff3f6;
  color: #2b579a;
}
.administration-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 30px;
  width: 1200px;
}
.administration-create,
.administration-logout {
  background-color: #fff;
  border-radius: 6px;
  color: #2b579a;
  font-size: 14px;
  margin-left: 6px;
  padding: 10px 20px;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
}
.administration-logout {
  background-color: #1a4280;
  border: 1px solid #fff;
  color: #fff;
}
.administration-create:hover {
  background-color: rgba(255, 255, 255, 0.9);
}
.administration-logout:hover {
  background-color: rgba(26, 66, 128, 0.8);
}
/* ITEMS ALL */
.administrations-item-ul {
  width: 100%;
}
.administrations-item-li {
  align-items: center;
  background-color: #fff;
  border-radius: 6px;
  -webkit-box-shadow: 0 0px 1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0px 1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin: 0 0 10px;
  padding: 0 20px;
}
.administrations-item-li:hover {
  background-color: #f9f9f9;
}
.administrations-item-date {
  opacity: 0.4;
  font-size: 14px;
  margin-right: 20px;
}
.item-icons {
  align-items: center;
  display: inline-flex;
}
.visible {
  margin-right: 10px;
}
.visible svg {
  align-items: center;
  display: flex;
  height: 25px;
  width: 25px;
}
.visible svg path {
  fill: #d1d4da;
}
.delete {
  cursor: pointer;
  display: flex;
  height: 20px;
  width: 20px;
}
.trash {
  width: 100%;
}
.delete .trash path {
  fill: #d1d4da;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -ms-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
}
.delete:hover .trash path {
  fill: #e26e6e;
}
.fade-enter-active,
.fade-leave-active {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.modal-enter-active,
.modal-leave-active {
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.modal-leave-to,
.modal-enter {
  opacity: 0;
  /* transform: translateY(-10%) !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/administration/Administration.vue